// One field of an AI answer's FORM proposal (components/AssistantThreadBlock.js
// BlockForm; functions/assistantAppForms.js assistantFormFields): the field's
// label in the house micro-label over the proposed value. Read-only — the
// member edits and saves in the app's own form.
export const AssistantFormField = {
  flow: 'y',
  gap: 'X',
  minWidth: '0',
  AppMicroLabel: { tag: 'dt', text: (el, s) => (s && s.label) || '' },
  FieldValue: {
    tag: 'dd',
    margin: '0',
    fontSize: 'Z1',
    color: 'title',
    overflowWrap: 'anywhere',
    text: (el, s) => (s && s.value) || ''
  }
}
